import styled from "@mui/material/styles/styled";

export const StaticImage = styled("img")({});
